import React, { Fragment, useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
import { Form, Row, Col, Button, Alert } from 'react-bootstrap';
import { BrandLogoURL, BrandLogoConf } from '../Auth/Login';
import AppOverlay from '../../components/Overlay/Overlay';
import { resetPassword } from '../../api/actions/Session';
import '../Auth/Login.scss';
import PageInformation from '../../components/PageInformation';
import LoginBackgroundURL from '../../assets/img/bg-login.jpeg';
import './ForgotPassword.scss';

const ForgotPassword = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [email, setEmail] = useState('');
    const [isFormValid, setIsFormValid] = useState(true);
    const [reqSent, setReqSent] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    
    useEffect(() => {
    }, [isFormValid, reqSent]);

    const validateEmail = (value) => {
        const regex = RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
        return regex.test(String(value));
    };

    const onChange = (event) => {
        setEmail(event.target.value);
        if (!isFormValid) {
            setIsFormValid(true);
        }
    }

    const onSubmit = async (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (!validateEmail(email) || email === '') {
            setIsFormValid(false);
            return;
        }
        setIsFormValid(true);
        setIsLoading(true);
        try {
            const sanitizedEmail = email.toLowerCase().trim();
            const { data } = await resetPassword(sanitizedEmail);
            if (data?.ok) {
                setReqSent(true);
            } else {
                setShowAlert(true);
            }
        } catch (e) {
            setShowAlert(true);
        }
        setIsLoading(false);
    }

    if (reqSent) {
        return (
            <PageInformation title="Forget my password">
                <div className="forgot-password" style={{backgroundImage: `url(${LoginBackgroundURL})`}}>
                    <div className="auth-box shadow p-4 pb-5 pt-5 mb-5rounded bg-blur-effect rounded">
                        <Row className="flex-column">
                            <Col className="text-center">
                                <img
                                    {...BrandLogoConf}
                                    className="mb-4"
                                    src={BrandLogoURL}
                                    alt="Brand logo"
                                />
                            </Col>
                            <Col lg={12} className={'align-self-center m-3 p-2'}>
                                A password reset link has been sent to the following address email: <strong>{email}</strong>.
                            </Col>
                            <Col>
                                <Button className="full-width" variant="link" href="/">Back to login page</Button>
                            </Col>
                        </Row>
                    </div>
                </div>
            </PageInformation>
        );
    }

    return (
        <PageInformation title="Forget my password">
            <div className="forgot-password" style={{backgroundImage: `url(${LoginBackgroundURL})`}}>
                <div className="auth-box shadow p-4 pb-5 pt-5 mb-5rounded bg-blur-effect rounded">
                    <Form onSubmit={onSubmit}>
                        <Row className="flex-column">
                            <Col className="text-center">
                                <img
                                    {...BrandLogoConf}
                                    className="mb-4"
                                    src={BrandLogoURL}
                                    alt="Brand logo"
                                />
                            </Col>
                            <Col lg={12} className={'align-self-center m-2 p-2'}>
                                <p>Enter your user account's email address and we will send you a password reset link.</p>
                            </Col>
                            <Col> 
                                <Form.Group className="mb-4">
                                    <Form.Control 
                                        type="email"
                                        name="email"
                                        value={email}
                                        onChange={onChange}
                                        placeholder="youremail@example.com"
                                        isInvalid={!isFormValid && email !== ''}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Invalid email address
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                            <Col> 
                                <Button className="d-block full-width" disabled={email === ''} type="Submit">
                                    SUBMIT
                                </Button>
                                <Link 
                                    className="full-width btn btn-link mt-3"
                                    role="button"
                                    to="/"
                                >
                                    Back to login page
                                </Link>
                            </Col>
                        </Row>
                    </Form>
                    {showAlert &&
                        <Alert 
                            key="danger"
                            variant="danger"
                            className={'mt-5'}
                            onClose={() => setShowAlert(false)}
                            dismissible
                        >
                            <p>Something wrong happened!<br />
                            Please try again later or contact your support.</p>
                        </Alert>
                    }
                </div>
            </div>
            <AppOverlay show={isLoading} />
        </PageInformation>
    );
};

export default ForgotPassword;
